const DISCIPLINES = ['math', 'reading'] as const

type Discipline = typeof DISCIPLINES[number] | 'both'

// The quiz grade select accepts K1–K12 only (see template-parts/quiz/step-child-details.php)
const MIN_GRADE = 1
const MAX_GRADE = 12
const getDisciplineFromPathname = (pathname: string): Discipline | null => {
  const matched = DISCIPLINES.filter(discipline => pathname.toLowerCase().includes(discipline))

  if (matched.length === 0) return null

  return matched.length === DISCIPLINES.length ? 'both' : matched[0]
}

const getGradeFromPathname = (pathname: string): string | null => {
  const matched = pathname.toLowerCase().match(/(\d+)(?:st|nd|rd|th)-grade/)
  if (!matched) return null

  const grade = Number(matched[1])
  if (grade < MIN_GRADE || grade > MAX_GRADE) return null

  return `K${grade}`
}

export const useQuizDisciplineGrade = (): void => {
  const quizElement = document.getElementById('quiz-link')
  const quizUrl = quizElement?.getAttribute('value') || ''
  if (!quizUrl) return

  const discipline = getDisciplineFromPathname(window.location.pathname)
  const grade = getGradeFromPathname(window.location.pathname)
  if (!discipline && !grade) return

  document.querySelectorAll<HTMLAnchorElement>('a[href]').forEach(link => {
    if (!link.href.includes(quizUrl)) return

    const url = new URL(link.href)
    if (discipline) url.searchParams.set('discipline', discipline)
    if (grade && !url.searchParams.has('grade')) url.searchParams.set('grade', grade)
    link.href = url.toString()
  })
}
